import { UserResponseDto } from '@headbox-ui/auth-hook/dist/useGlobalAuth'

const mapActorToPFUser = (user: UserResponseDto): ProductFruitsUser => ({
  username: user.id,
  email: user.email,
  firstname: user.firstName ?? '',
  lastname: user.lastName,
  role: user.roles.join(', '),
  props: {
    country: user.country,
  },
  // signUpAt: user.createdAt - not yet implemented in auth-system
})

export default mapActorToPFUser
